module.exports = __webpack_public_path__ + "media/images/client-27-22edb0a76cf83a149febe470b9a1ee3e.png";